/*
 * 统一管理从服务端获取的数据，方便后期维护
 * 通过export  暴露封装的获取数据方法
 */
import Axios from "axios";

const industryAnalyze = process.env.VUE_APP_SERVER_URL
//列表
export const ListApi = (data) => Axios.get(industryAnalyze + '/ent-bj/page', data)
//新增或修改
export const AddApi = (data) => Axios.post(industryAnalyze + '/ent-bj/save', data)
//查看
export const SeeApi = (data) => Axios.get(industryAnalyze + '/ent-bj/bjEnt', data)
// 删除
export const DelApi = (data) => Axios.delete(industryAnalyze + '/ent-bj/delBjEnt', data)
//获取北京地区
export const districtsApi = (data) => Axios.get(industryAnalyze + '/dict/district/districts', data);
//获取全部行业
export const industriesApi = (data) => Axios.get(industryAnalyze + '/dict/industry/industries', data);
